<template>
    <require from="../../parent-child-select/parent-child-select"></require>
    <parent-child-select
      objecttypetoadd.bind="'Procedure'"
      sortable.bind="'true'"
      items.bind="selectedObjectService.selectedObject.procedures"
    >
    </parent-child-select>
</template>
